<app-badge badgeType="dark" *ngIf="sent">
	Sent {{sentInfo}}
</app-badge>
<app-badge badgeType="warning" *ngIf="!sent">
	Waiting
</app-badge>